/* TrustSignalsSection.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _19 = "._k48p1nn1{font-weight:400}";
const _18 = "._19pku2gc{margin-top:var(--ds-space-100,8px)}";
const _17 = "._k48p1fw0{font-weight:700}";
const _16 = "@media (min-width:48rem) and (max-width:63.99rem){._1b7e1ejb{margin-bottom:var(--ds-space-300,24px)}}";
const _15 = "._4cvr1h6o{align-items:center}";
const _14 = "._2lx21bp4{flex-direction:column}";
const _13 = "._1bah1h6o{justify-content:center}";
const _12 = "._1e0c1txw{display:flex}";
const _11 = "@media (min-width:48rem){._1svy1ejb{margin-bottom:var(--ds-space-300,24px)}}";
const _10 = "._otyrpxbi{margin-bottom:var(--ds-space-200,1pc)}";
const _9 = "._y3gn1h6o{text-align:center}";
const _8 = "@media (min-width:64rem){._pdlmxy5q{gap:var(--ds-space-400,2pc)}._dbjg1wug{margin-top:auto}._1hvk1wug{margin-right:auto}._isu41wug{margin-bottom:auto}._15qm1wug{margin-left:auto}._1rqt16hb{grid-template-columns:repeat(3,1fr)}._10jx1es0{max-width:858pt}}";
const _7 = "@media (min-width:48rem) and (max-width:63.99rem){._1gzv1ejb{gap:var(--ds-space-300,24px)}._1da7fsjm{grid-template-columns:repeat(2,1fr)}}";
const _6 = "._19bvidpf{padding-left:0}";
const _5 = "._yv0e1ttp{grid-template-columns:repeat(1,1fr)}";
const _4 = "._1e0c11p5{display:grid}";
const _3 = "._zulp1ejb{gap:var(--ds-space-300,24px)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives/responsive';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { BodyLarge, H3 } from '@atlassian/mpac-primitives';
import React from 'react';
import { trustSignals } from './constants';
import { TrustSignalCard } from './TrustSignalCard';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _2 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const _ = "._19pkpxbi{margin-top:var(--ds-space-200,1pc)}";
const Description = forwardRef((_ref, __cmplr) => {
  let {
      as: C = BodyLarge,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkpxbi _syaz1gjq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Description.displayName = 'Description';
}
export const TrustSignalsWrapper = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "dl",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_3, _4, _5, _6, _7, _8]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulp1ejb _1e0c11p5 _yv0e1ttp _19bvidpf _1gzv1ejb _1da7fsjm _pdlmxy5q _dbjg1wug _1hvk1wug _isu41wug _15qm1wug _1rqt16hb _10jx1es0", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TrustSignalsWrapper.displayName = 'TrustSignalsWrapper';
}
export const SectionHeader = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_9, _10, _11]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_y3gn1h6o _otyrpxbi _1svy1ejb", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SectionHeader.displayName = 'SectionHeader';
}
const SectionHeaderStyle = null;
const DescriptionStyle = null;
const H3Style = null;
export const TrustSignalsSection = () => {
  const {
    enableMpacWebCoherence
  } = useStatsig();
  if (enableMpacWebCoherence()) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_12, _13, _14, _15, _16]
        }), /*#__PURE__*/_jsxs("div", {
          className: ax(["_1e0c1txw _1bah1h6o _2lx21bp4 _4cvr1h6o _1b7e1ejb"]),
          children: [/*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_17, _9]
            }), /*#__PURE__*/_jsx(H3, {
              as: "h2",
              className: ax(["_k48p1fw0 _y3gn1h6o"]),
              children: "Unlock endless possibilities with apps"
            })]
          }), /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_18, _19, _9]
            }), /*#__PURE__*/_jsx(BodyLarge, {
              className: ax(["_19pku2gc _k48p1nn1 _y3gn1h6o"]),
              children: "Delve into our extensive repository of apps, supported by our partners; and bolster your growth with Atlassian ecosystem."
            })]
          })]
        })]
      }), /*#__PURE__*/_jsx(TrustSignalsWrapper, {
        children: trustSignals.map(trustSignal => {
          const {
            id,
            stats,
            label,
            cardStyles,
            statsStyles
          } = trustSignal;
          return /*#__PURE__*/_jsx(TrustSignalCard, {
            stats: stats,
            label: label,
            cardStyles: cardStyles,
            statsStyles: statsStyles,
            isWebCoherenceEnabled: true
          }, id);
        })
      })]
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(SectionHeader, {
      children: [/*#__PURE__*/_jsx(H3, {
        as: "h2",
        children: "Unlock endless possibilities with apps"
      }), /*#__PURE__*/_jsx(Description, {
        children: "Delve into our extensive repository of apps, supported by our partners; and bolster your growth with Atlassian ecosystem."
      })]
    }), /*#__PURE__*/_jsx(TrustSignalsWrapper, {
      children: trustSignals.map(trustSignal => {
        const {
          id,
          stats,
          label,
          cardStyles,
          statsStyles
        } = trustSignal;
        return /*#__PURE__*/_jsx(TrustSignalCard, {
          stats: stats,
          label: label,
          cardStyles: cardStyles,
          statsStyles: statsStyles,
          isWebCoherenceEnabled: false
        }, id);
      })
    })]
  });
};